import { ApiResponse } from '@/types';
import api from './client';

// Profile API
export const profileAPI = {
  getMe: async (): Promise<ApiResponse<{ id: string; name: string; email: string; role: string; createdAt: string; updatedAt: string; lastLogin: string }>> => {
    const response = await api.get('/profile');
    return response.data;
  },
  changePassword: async (currentPassword: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.put('/profile/password', { currentPassword, newPassword });
    return response.data;
  },
  getActivity: async (limit = 50, offset = 0): Promise<ApiResponse<Array<{
    id: string;
    action: string;
    entityType?: string;
    entityId?: string;
    description: string;
    metadata?: Record<string, unknown>;
    createdAt: string;
  }>>> => {
    const response = await api.get(`/profile/activity?limit=${limit}&offset=${offset}`);
    return response.data;
  },
};
